import React, { ChangeEvent, useState } from 'react';

import { MainModalController, Modal, ModalCloseButton } from '@uikit/components/Modal';
import ModalContent from '@uikit/components/Modal/ModalContent';
import ModalHeading from '@uikit/components/Modal/ModalHeading';

interface SlippageModalProps {
  modalController: MainModalController;
  setSlippage: (value: number) => void;
  slippage: number;
}

const SlippageModal = ({ modalController, slippage, setSlippage }: SlippageModalProps) => {
  const [value, setValue] = useState(slippage);

  const save = async () => {
    setSlippage(value);
    modalController.close();
  };

  const handleChange = ({ target: { value: v } }: ChangeEvent<HTMLInputElement>) => {
    const numValue = +v;

    if (numValue < 0 || numValue > 50) {
      return;
    }

    setValue(numValue);
  };

  return (
    <Modal {...modalController.props}>
      <ModalContent className="w-full max-w-[472px] py-[24px] px-[48px]">
        <ModalCloseButton className="mb-4" />

        <ModalHeading className="mb-4">Slippage Tolerance</ModalHeading>

        <input
          min={0}
          max={50}
          className="h-10 w-full rounded-full border border-primary-400 px-4 flex items-center"
          type="number"
          step="0.1"
          value={value}
          onChange={handleChange}
        />

        <button className="button button-primary button-lg mt-[32px]" onClick={save}>
          Save
        </button>
      </ModalContent>
    </Modal>
  );
};

export default SlippageModal;
